import type { Errors } from './types';

const errors: Errors = [
	{
		id: 1,
		title: 'Error',
		message: 'Not able to fetch data',
		locationHash: '#plan/backlog',
		locationPath: undefined,
	},
	{
		id: 2,
		title: 'Error',
		message: 'Not able to call ReST endpoint',
		locationHash: '#plan/teams',
		locationPath: undefined,
	},
];

export default errors;
